/*
* @Author: CJ Ting
* @Date:   2016-07-14 14:47:13
* @Last Modified by:   CJ Ting
* @Last Modified time: 2017-05-24 16:02:00
*/

import "./index.css"

import React from "react"
import PropTypes from "prop-types"
import DOM from "react-dom"

class Dialog extends React.Component {
  componentDidMount() {
    // prevent `ios touch event does not obey z-index` bug
    // https://github.com/scottjehl/Device-Bugs/issues/14
    const content = this.refs.content
    this.refs.root.addEventListener("touchmove", evt => {
      if(!content.contains(evt.target)) {
        evt.preventDefault()
      }
    })
    content.addEventListener("touchmove", evt => {
      const overflowed = content.offsetHeight < content.scrollHeight
      if(!overflowed) {
        evt.preventDefault()
      }
    })
  }

  destroy = () => {
    const node = this.refs.root.parentNode
    DOM.unmountComponentAtNode(node)
    node.remove()
  }

  ok = () => {
    if(this.props.okButtonDisabled) return
    if(this.props.okButtonCB) {
      this.props.okButtonCB(this)
    } else {
      this.destroy()
    }
  }

  cancel = () => {
    if(this.props.cancelButtonCB) {
      this.props.cancelButtonCB(this)
    } else {
      this.destroy()
    }
  }

  render() {
    const klass = this.props.className ?
      "react-dialog " + this.props.className
      :
      "react-dialog"

    return (
      <div
        ref="root"
        className={ klass }
      >
        <div className="react-dialog__container">
          <header className="react-dialog__header">
            { this.props.title }
            <div
              className="react-dialog__close-btn"
              onClick={ this.destroy }
            >
              ×
            </div>
          </header>

          <div
            className="react-dialog__content"
            ref="content"
          >
            { this.props.children }
          </div>

          <div className="react-dialog__buttons">
            <div
              className={ `react-dialog__ok-btn ${this.props.okButtonDisabled ? "react-dialog__ok-btn--disabled" : ""}`}
              onClick={ this.ok }
            >
              { this.props.okButtonText }
            </div>

            {
              this.props.hideCancelButton ?
                null
                :
                <div
                  onClick={ this.cancel }
                  className="react-dialog__cancel-btn"
                >
                  { this.props.cancelButtonText }
                </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

Dialog.defaultProps = {
  okButtonText: "Ok",
  cancelButtonText: "Cancel",
  hideCancelButton: false,
}

Dialog.propTypes = {
  className: PropTypes.string,
  okButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  okButtonCB: PropTypes.func,
  cancelButtonCB: PropTypes.func,
  hideCancelButton: PropTypes.bool,
  title: PropTypes.string,
  okButtonDisabled: PropTypes.bool,
}

const showDialog = (Cmp, props) => {
  const div = document.createElement("div")
  div.className = "react-dialog-mountpoint"
  document.body.appendChild(div)
  DOM.render(<Cmp {...props}/>, div)
}

export { Dialog, showDialog }



// WEBPACK FOOTER //
// ./src/index.jsx